import fundaNowClient from '@/client/fundaNowClient'

export default {
  postSubscription(data) {
    return fundaNowClient.call({
      url: '/todaystore/subscription/',
      method: 'POST',
      data: data
    })
  },
  getSubscription(data) {
    return fundaNowClient.call({
      url: '/todaystore/subscription-exists/',
      method: 'POST',
      data: {
        'phone': data
      }
    })
  },
}
